/* ==========================================================================
   KIOSK JS — cart drawer, add-to-order, quantity controls.
   Vanilla JS, no dependencies. Everything degrades gracefully: with JS off,
   product forms post to /cart and the cart page takes over.
   ========================================================================== */

(function () {
  'use strict';

  var drawer = null;
  var overlay = null;
  var lastFocused = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- Drawer open/close -------------------------------------------- */

  function openDrawer() {
    drawer = q('[data-cart-drawer]');
    overlay = q('[data-cart-close-overlay]');
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = q('[data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  /* ---- Cart drawer re-render (Section Rendering API) ----------------- */

  function refreshDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var freshRoot = q('[data-cart-drawer-root]', tmp);
        var currentRoot = q('[data-cart-drawer-root]');
        if (freshRoot && currentRoot) {
          currentRoot.replaceWith(freshRoot);
          drawer = null; // re-query on next open
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) {
          qa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        }
        if (openAfter) openDrawer();
      });
  }

  /* ---- Add to order (intercept product forms) ------------------------ */

  function handleAddToCart(form) {
    var btn = q('[type="submit"]', form);
    if (btn) btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return refreshDrawer(true);
      })
      .catch(function (err) {
        var msg = (err && err.description) || 'Could not add that investment.';
        var out = q('[data-form-error]', form);
        if (out) { out.textContent = msg; out.hidden = false; }
      })
      .then(function () {
        if (btn) btn.classList.remove('is-busy');
      });
  }

  /* ---- Quantity +/- inside the receipt -------------------------------- */

  function handleQtyChange(el) {
    var parts = el.getAttribute('data-qty-change').split(':');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(parts[0]), quantity: Number(parts[1]) })
    }).then(function () { return refreshDrawer(true); });
  }

  /* ---- Product page: keep price/availability in sync with variant ---- */

  function initProductForm(form) {
    var root = form.closest('[data-product]') || document;
    var variantData = q('[data-variant-json]', root);
    if (!variantData) return;
    var variants = JSON.parse(variantData.textContent);

    var stageImg = q('[data-media-main]', root);
    var thumbs = qa('[data-media-thumb]', root);

    /* ---- Gallery: show one image on the stage --------------------------- */

    function showMedia(mediaId, src) {
      if (stageImg && src) {
        stageImg.src = src;
        stageImg.removeAttribute('srcset');
      }
      if (!mediaId) return;
      var wanted = String(mediaId);
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-media-thumb') === wanted;
        t.classList.toggle('is-active', active);
        if (active && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showMedia(t.getAttribute('data-media-thumb'), t.getAttribute('data-media-src'));
      });
    });

    /* ---- Options -> variant --------------------------------------------- */

    function optionInputs() {
      return qa('input[type="radio"][name^="option-"]', form);
    }

    function optionIndex(el) {
      return Number(el.name.slice('option-'.length));
    }

    function selectedOptions() {
      var vals = [];
      optionInputs().forEach(function (el) {
        if (el.checked) vals[optionIndex(el)] = el.value;
      });
      return vals;
    }

    function syncOptionInputs(variant) {
      optionInputs().forEach(function (el) {
        el.checked = el.value === variant.options[optionIndex(el)];
      });
    }

    function syncOptionLabels() {
      optionInputs().forEach(function (el) {
        if (!el.checked) return;
        var out = q('[data-option-current="' + optionIndex(el) + '"]', root);
        if (out) out.textContent = el.value;
      });
    }

    function apply(variant) {
      var idInput = q('[name="id"]', form);
      if (idInput) idInput.value = variant.id;

      var priceEl = q('[data-product-price]', root);
      if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;

      var btn = q('[type="submit"]', form);
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
      }

      showMedia(variant.media_id, variant.image);
      syncOptionLabels();
    }

    form.addEventListener('change', function (e) {
      var changed = e.target;
      if (changed && changed.name === 'quantity') return;

      var selected = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      /* The picked combination does not exist (common on garments where not
         every colour comes in every size) — fall back to the first available
         variant that honours the key the shopper just pressed, and move the
         other keys to match instead of silently doing nothing. */
      if (!match && changed && changed.name && changed.name.indexOf('option-') === 0) {
        var idx = optionIndex(changed);
        var candidates = variants.filter(function (v) { return v.options[idx] === changed.value; });
        match = candidates.find(function (v) { return v.available; }) || candidates[0];
        if (match) syncOptionInputs(match);
      }

      if (!match) return;
      apply(match);
    });
  }

  /* ---- Wire it all up (event delegation survives drawer re-renders) -- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-close-overlay]')) closeDrawer();
    var qty = e.target.closest('[data-qty-change]');
    if (qty) handleQtyChange(qty);

    /* Port Navi fast-travel picker */
    var pn = q('[data-pn]');
    if (pn) {
      if (e.target.closest('[data-pn-open]')) pn.hidden = false;
      if (e.target.closest('[data-pn-close]') || e.target === pn) pn.hidden = true;

      var lockedDest = e.target.closest('[data-pn-locked]');
      if (lockedDest) {
        lockedDest.classList.remove('is-shake');
        void lockedDest.offsetWidth;
        lockedDest.classList.add('is-shake');
      }

      var dest = e.target.closest('[data-pn-dest]');
      if (dest) {
        e.preventDefault();
        var name = dest.getAttribute('data-pn-name') || 'Destination';
        var href = dest.getAttribute('href');
        var toast = q('[data-pn-toast]');
        if (!href || href === '#') {
          if (toast) {
            toast.textContent = '▸ ' + name.toUpperCase() + ' · WING UNDER CONSTRUCTION';
            toast.hidden = false;
            clearTimeout(toast._t);
            toast._t = setTimeout(function () { toast.hidden = true; }, 2400);
          }
        } else {
          pn.hidden = true;
          if (toast) {
            toast.textContent = '▸ ARRIVING · ' + name.toUpperCase();
            toast.hidden = false;
          }
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var flick = q('[data-pn-flick]');
          if (!reduced && flick) {
            /* Hold until the 340ms dim has finished, so navigation happens
               behind a fully faded screen rather than mid-fade. Absent when
               the merchant switches the effect off in Theme settings. */
            flick.classList.add('is-on');
            setTimeout(function () { window.location.href = href; }, 360);
          } else {
            window.location.href = href;
          }
        }
      }
    }

    /* Floor maps overlay */
    var maps = q('[data-maps]');
    if (maps) {
      if (e.target.closest('[data-maps-open]')) maps.hidden = false;
      if (e.target.closest('[data-maps-close]') || e.target === maps) maps.hidden = true;
      var tab = e.target.closest('[data-maps-tab]');
      if (tab) {
        qa('[data-maps-tab]', maps).forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        qa('[data-maps-view]', maps).forEach(function (v) {
          v.hidden = v.getAttribute('data-maps-view') !== tab.getAttribute('data-maps-tab');
        });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      var maps = q('[data-maps]');
      if (maps) maps.hidden = true;
      var pn = q('[data-pn]');
      if (pn) pn.hidden = true;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]')) {
      e.preventDefault();
      handleAddToCart(form);
    }
  });

  qa('[data-product-form]').forEach(initProductForm);

  /* ---- Lobby intro: tap the standing kiosk to zoom into the screen ---- */

  var intro = document.getElementById('kIntro');
  if (intro) {
    if (sessionStorage.getItem('kIntroSeen')) {
      intro.remove();
    } else {
      intro.addEventListener('click', function () {
        sessionStorage.setItem('kIntroSeen', '1');
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) { intro.remove(); return; }
        intro.classList.add('is-zoom');
        intro.addEventListener('animationend', function () { intro.remove(); });
        /* safety net in case the animation never fires */
        setTimeout(function () { if (intro.parentNode) intro.remove(); }, 1200);
      });
    }
  }
})();
